import { render, staticRenderFns } from "./cv-switcher-item-link.vue?vue&type=template&id=da33c4e8&"
import script from "./cv-switcher-item-link.vue?vue&type=script&lang=js&"
export * from "./cv-switcher-item-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports